export const TaskKeysAnotherDoc = [
  'purchase',
  'payoff',
  'entity_docs',
  null //New tasks  
];